import React from 'react';

import { GlovesVideo } from './GlovesVideo/GlovesVideo';
import { HeaderForm } from './HeaderForm/HeaderForm';
import { ThePrize } from './ThePrize/ThePrize';

import styles from './DrivingGlovesPrizeDraw.scss';

export const DrivingGlovesPrizeDraw: React.FC = () => <div className={styles.prizeDraw}>
  <HeaderForm />
  <ThePrize />
  <GlovesVideo />
</div>;

export default DrivingGlovesPrizeDraw;
